import { useQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CCA_SETTINGS_QUERY } from './ccaSettings.query';
import { CcaSettingsQuery, CcaSettingsQueryVariables } from './__generated__/CcaSettingsQuery';

export const useCcaSettingsQuery = (id: string, skip = false) => {
  return useQuery<CcaSettingsQuery, CcaSettingsQueryVariables>(CCA_SETTINGS_QUERY, {
    client: kmsClient,
    variables: { id },
    skip,
    fetchPolicy: 'cache-and-network'
  });
};
